export interface DiagnosisOption {
  label: string;
  value: string;
  desc: string;
  tags: string[];
}

export interface DiagnosisQuestion {
  id: number;
  question: string;
  options: DiagnosisOption[];
}

export const diagnosisQuestions: Record<string, DiagnosisQuestion[]> = {
  dress: [
    {
      id: 1,
      question: '어떤 기준으로 예복 업체를 보고 싶나요?',
      options: [
        {
          label: '실속 중심',
          value: 'value',
          desc: '브랜드보다는 가성비가 중요해요.',
          tags: ['종로 / 기타 지역 중심', '70~90만원대부터 비교'],
        },
        {
          label: '프리미엄 중심',
          value: 'premium',
          desc: '상담 경험과 브랜드 신뢰도가 중요해요.',
          tags: ['청담 중심', '100~130만원 이상 고려'],
        },
        {
          label: '디자인 우선',
          value: 'design',
          desc: '디자인 스타일과 핏이 가장 중요해요.',
          tags: ['스타일 다양한 곳', '수선 퀄리티 확인'],
        },
        {
          label: '대여 전문',
          value: 'rental_focus',
          desc: '대여 위주로 경제적으로 준비하고 싶어요.',
          tags: ['촬영+본식 패키지', '반납 조건 확인'],
        },
      ],
    },
    {
      id: 2,
      question: '어떤 제작 방식이 가장 끌리나요?',
      options: [
        {
          label: '대여로 충분해요',
          value: 'rental',
          desc: '가장 경제적이고 촬영용/본식용을 구분하기 좋아요.',
          tags: ['비용 부담 적음', '빠른 준비 가능'],
        },
        {
          label: '맞춤이 좋아요',
          value: 'custom',
          desc: '내 체형에 맞는 핏을 중요하게 생각해요.',
          tags: ['체형 반영', '수선 부담 적음'],
        },
        {
          label: '반수제를 원해요',
          value: 'semi',
          desc: '완성도와 가성비를 함께 보고 싶어요.',
          tags: ['기성복+맞춤 수선', '만족도 균형'],
        },
        {
          label: '수제가 끌려요',
          value: 'bespoke',
          desc: '원단과 디테일, 장인 완성도를 가장 중요하게 생각해요.',
          tags: ['최고 퀄리티', '프리미엄 예산대'],
        },
      ],
    },
    {
      id: 3,
      question: '촬영용 대여복과 본식 예복 중 무엇이 더 중요한가요?',
      options: [
        {
          label: '본식 예복이 훨씬 중요해요',
          value: 'ceremony',
          desc: '웨딩데이 실제 퀄리티를 가장 중시해요.',
          tags: ['본식 핏 확인', '수선 서비스 중요'],
        },
        {
          label: '촬영용도 중요해요',
          value: 'photo',
          desc: '사진 결과물도 신경 쓰이는 편이에요.',
          tags: ['스튜디오 대여 구성', '촬영 분위기 고려'],
        },
        {
          label: '둘 다 중요해요',
          value: 'both',
          desc: '패키지로 한 번에 준비하고 싶어요.',
          tags: ['대여+구매 복합', '패키지 가격 비교'],
        },
        {
          label: '아직 모르겠어요',
          value: 'unsure',
          desc: '업체 상담 후 결정하고 싶어요.',
          tags: ['상담 시 구성 설명', '패키지 옵션 확인'],
        },
      ],
    },
    {
      id: 4,
      question: '업체를 고를 때 가장 중요한 기준은?',
      options: [
        {
          label: '가격대가 합리적이어야 해요',
          value: 'price',
          desc: '예산 안에서 최적의 퀄리티를 찾고 싶어요.',
          tags: ['투명한 가격 공개', '패키지 구성 확인'],
        },
        {
          label: '후기 사진이 많으면 좋겠어요',
          value: 'reviews',
          desc: '실제 착용 결과물이 궁금해요.',
          tags: ['실제 후기 기반', '사진 분위기 확인'],
        },
        {
          label: '상담 친절도가 중요해요',
          value: 'consultation',
          desc: '처음이라 상담이 편안해야 해요.',
          tags: ['전문 상담사', '친절한 응대'],
        },
        {
          label: '수선과 A/S가 체계적이어야 해요',
          value: 'afterservice',
          desc: '사후 관리가 확실한 곳을 찾아요.',
          tags: ['무상 수선', '응급 수선 가능'],
        },
      ],
    },
  ],
  jewelry: [
    {
      id: 1,
      question: '어떤 예물을 준비하고 싶나요?',
      options: [
        {
          label: '커플링만 준비해요',
          value: 'couple',
          desc: '웨딩밴드 중심, 매일 착용하는 반지예요.',
          tags: ['14K~18K', '디자인 중심'],
        },
        {
          label: '다이아 반지도 포함',
          value: 'diamond',
          desc: '프로포즈 링과 웨딩밴드를 함께 준비해요.',
          tags: ['1부~3부 다이아', '보증서 확인'],
        },
        {
          label: '아직 결정 못했어요',
          value: 'undecided',
          desc: '상담 후 구성을 함께 정하고 싶어요.',
          tags: ['상담 시 구성 추천', '유연한 예산'],
        },
      ],
    },
    {
      id: 2,
      question: '브랜드와 공방 중 어디에 더 끌리나요?',
      options: [
        {
          label: '브랜드 매장',
          value: 'brand',
          desc: '보증서 확실, A/S 체계적, 디자인 일관성이 중요해요.',
          tags: ['공식 보증서', '전국 A/S'],
        },
        {
          label: '공방',
          value: 'workshop',
          desc: '직접 제작 참여, 커스텀 디자인, 가격 유연성이 매력적이에요.',
          tags: ['커스텀 가능', '가격 협의'],
        },
        {
          label: '둘 다 비교하고 싶어요',
          value: 'both',
          desc: '브랜드 디자인과 공방 가격대를 함께 보고 싶어요.',
          tags: ['하이브리드 검토', '다양한 옵션'],
        },
      ],
    },
    {
      id: 3,
      question: '가장 중요한 기준은 무엇인가요?',
      options: [
        {
          label: '디자인',
          value: 'design',
          desc: '취향과 착용감이 우선이에요.',
          tags: ['스타일 다양한 곳', '피팅 서비스'],
        },
        {
          label: 'A/S 조건',
          value: 'afterservice',
          desc: '수리, 사이즈 조정, 평생 서비스가 중요해요.',
          tags: ['평생 사이즈 조정', '무상 수리'],
        },
        {
          label: '보증서',
          value: 'certificate',
          desc: '다이아 등급, 금 함량 인증이 확실해야 해요.',
          tags: ['GIA 인증', '금 함량 표기'],
        },
        {
          label: '가격',
          value: 'price',
          desc: '예산 안에서 최선의 품질을 찾고 싶어요.',
          tags: ['투명한 가격', '할인 이벤트'],
        },
      ],
    },
    {
      id: 4,
      question: '예산 범위는 어느 정도인가요?',
      options: [
        {
          label: '100~250만원',
          value: 'budget1',
          desc: '실버/14K 커플링 입문 단계예요.',
          tags: ['입문용 브랜드', '가성비 중심'],
        },
        {
          label: '250~400만원',
          value: 'budget2',
          desc: '18K + 다이아 포함 세트를 고려해요.',
          tags: ['다이아 포함 가능', '브랜드 선택폭 넓음'],
        },
        {
          label: '400~600만원',
          value: 'budget3',
          desc: '브랜드 다이아 반지를 원해요.',
          tags: ['브랜드 다이아', '보증서 확실'],
        },
        {
          label: '600만원 이상',
          value: 'budget4',
          desc: '하이엔드 브랜드, 희소 다이아를 고려해요.',
          tags: ['하이엔드 브랜드', '희소 다이아'],
        },
      ],
    },
  ],
  hanbok: [
    {
      id: 1,
      question: '누가 한복을 입을 예정인가요?',
      options: [
        {
          label: '신랑신부만',
          value: 'couple',
          desc: '본식 입장용, 사진 촬영용으로 신랑신부만 준비해요.',
          tags: ['2인 세트', '비교적 간단'],
        },
        {
          label: '혼주도 포함',
          value: 'parents',
          desc: '양가 부모님, 형제자매까지 포함해서 준비해요.',
          tags: ['다인 세트', '일괄 예약 권장'],
        },
        {
          label: '아직 모르겠어요',
          value: 'unsure',
          desc: '상담 후 착용 대상을 함께 정하고 싶어요.',
          tags: ['유연한 구성 변경', '단계적 예약'],
        },
      ],
    },
    {
      id: 2,
      question: '맞춤과 대여 중 어떤 쪽이 끌리나요?',
      options: [
        {
          label: '맞춤이 좋아요',
          value: 'custom',
          desc: '내 몸에 맞는 핏, 기념 보존 가능, 높은 퀄리티를 원해요.',
          tags: ['체형 반영', '기념 보존'],
        },
        {
          label: '대여가 좋아요',
          value: 'rental',
          desc: '경제적, 다양한 디자인 선택, 보관 부담 없음이 장점이에요.',
          tags: ['비용 부담 적음', '보관 걱정 없음'],
        },
        {
          label: '둘 다 고민 중',
          value: 'both',
          desc: '촬영 대여 + 본식 맞춤 하이브리드를 고려해요.',
          tags: ['하이브리드 구성', '단계적 준비'],
        },
      ],
    },
    {
      id: 3,
      question: '원하는 분위기는 무엇인가요?',
      options: [
        {
          label: '전통적이고 화려한',
          value: 'traditional',
          desc: '붉은색, 초록색, 금박 등 고전적 무게감이 좋아요.',
          tags: ['금박/자수', '전통 색감'],
        },
        {
          label: '모던하고 깔끔한',
          value: 'modern',
          desc: '파스텔톤, 미니멀 디자인, 데일리 감각을 선호해요.',
          tags: ['파스텔톤', '미니멀 디자인'],
        },
        {
          label: '클래식하고 무게감 있는',
          value: 'classic',
          desc: '검정·남색 계열, 격식 있는 분위기를 원해요.',
          tags: ['남색/검정', '격식 있는 디자인'],
        },
        {
          label: '유니크한',
          value: 'unique',
          desc: '특별한 디자인, 색상으로 차별화를 원해요.',
          tags: ['커스텀 디자인', '특별한 색상'],
        },
      ],
    },
    {
      id: 4,
      question: '가장 중요한 기준은 무엇인가요?',
      options: [
        {
          label: '피팅 일정',
          value: 'fitting',
          desc: '본식 전 2~3회 피팅이 가능해야 해요.',
          tags: ['피팅 횟수', '일정 조율'],
        },
        {
          label: '반납 조건',
          value: 'return',
          desc: '택배/방문 반납, 세탁 여부, 연체료가 명확해야 해요.',
          tags: ['택배 반납', '세탁 포함 여부'],
        },
        {
          label: '원단 품질',
          value: 'fabric',
          desc: '실크, 명주, 인조실크 등 원단 차이를 중요하게 봐요.',
          tags: ['실크/명주', '원단 등급'],
        },
        {
          label: '가격',
          value: 'price',
          desc: '예산 안에서 최선의 디자인과 품질을 찾고 싶어요.',
          tags: ['패키지 할인', '구성별 가격 비교'],
        },
      ],
    },
  ],
};